<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M9.6 4.8c-1.27304 0-2.49394.50571-3.39411 1.40589C5.30571 7.10606 4.8 8.32696 4.8 9.6c0 1.273.50571 2.4939 1.40589 3.3941C7.10606 13.8943 8.32696 14.4 9.6 14.4c1.273 0 2.4939-.5057 3.3941-1.4059C13.8943 12.0939 14.4 10.873 14.4 9.6c0-1.27304-.5057-2.49394-1.4059-3.39411C12.0939 5.30571 10.873 4.8 9.6 4.8ZM2.4 9.6c-.00014-1.13316.26717-2.25035.78021-3.26071.51303-1.01037 1.2573-1.88537 2.17227-2.55386.91496-.66849 1.9748-1.11158 3.0933-1.29323 1.1185-.18166 2.26412-.09675 3.34362.24782 1.0795.34457 2.0624.93906 2.8688 1.73513.8064.79608 1.4136 1.77125 1.772 2.84621.3585 1.07496.4582 2.21935.291 3.34014-.1672 1.1207-.5966 2.1862-1.2532 3.1097l5.7804 5.7804c.2186.2263.3395.5294.3368.8441-.0027.3146-.1289.6156-.3514.8381-.2225.2225-.5235.3487-.8381.3514-.3147.0027-.6178-.1182-.8441-.3368l-5.7792-5.7792c-1.0772.7659-2.3444 1.2206-3.6628 1.3141-1.31839.0936-2.63711-.1776-3.81164-.7837-1.17453-.6062-2.15953-1.524-2.84709-2.6528S2.39974 10.9217 2.4 9.6Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M10 4c-1.5913 0-3.11742.63214-4.24264 1.75736C4.63214 6.88258 4 8.4087 4 10c0 .7879.15519 1.5681.45672 2.2961s.74349 1.3894 1.30064 1.9465c.55715.5572 1.21859.9991 1.94654 1.3007C8.43185 15.8448 9.21207 16 10 16c.7879 0 1.5681-.1552 2.2961-.4567.728-.3016 1.3894-.7435 1.9465-1.3007.5572-.5571.9991-1.2185 1.3007-1.9465C15.8448 11.5681 16 10.7879 16 10c0-1.5913-.6321-3.11742-1.7574-4.24264C13.1174 4.63214 11.5913 4 10 4Zm-5.65685.34315C5.84344 2.84285 7.87827 2 10 2c2.1217 0 4.1566.84285 5.6569 2.34315C17.1571 5.84344 18 7.87827 18 10c0 1.0506-.2069 2.0909-.609 3.0615-.2738.6611-.6345 1.281-1.0714 1.8439l5.3875 5.3875c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0l-5.3875-5.3875c-.5629.4369-1.1828.7976-1.8439 1.0714-.9706.4021-2.0109.609-3.0615.609-1.05057 0-2.09086-.2069-3.06147-.609-.9706-.402-1.85252-.9913-2.59538-1.7341-.74287-.7429-1.33215-1.6248-1.73419-2.5954C2.20693 12.0909 2 11.0506 2 10c0-2.12173.84285-4.15656 2.34315-5.65685Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
